import {Directive, Input, ElementRef, AfterViewInit, AfterContentInit} from 'angular2/core';
import {NgControlName} from 'angular2/common';

/*
    Select2 is a library to build custom <select> element that allow us to perform:
        * autocomplete
        * fancy multiple select
        * search
        * and more
    See more https://select2.github.io/
 */

@Directive({
    selector: "[select2]"
})

export class Select2 implements AfterViewInit, AfterContentInit {
    @Input('select2') control:NgControlName;
    private _element:JQuery;

    constructor(private _elementRef:ElementRef) {
        this._element = jQuery(_elementRef.nativeElement);
    }

    ngAfterViewInit() {
        this._element.select2({
            theme: "bootstrap",
            language: "fr", //TODO get local
            width: "100%",
            minimumResultsForSearch: 8
        });
    }

    fnChange ($event) {
        if (this.control.viewModel !== this._element.val()) {
            this.control.viewToModelUpdate(this._element.val());
        }
    }

    ngAfterContentInit() {
        this._element.val(this.control.viewModel).trigger("change");
        this._element.on("change", this.fnChange.bind(this));
    }
}
